<template>
  <div>
    <FiltersDesktopVersion
      :category-options
      class="hidden md:block"
      :initial-values
      :market-options
      @submit="handleSubmit"
    />
    <FiltersMobileVersion
      :category-options
      class="md:hidden"
      :initial-values
      :market-options
      @submit="handleSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import { mergeObject } from '@/utils/mergeObject'

import type { FilterValues } from './Filters.types'
import { getInitialValues } from './Filters.utils'
import FiltersDesktopVersion from './components/FiltersDesktopVersion.vue'
import FiltersMobileVersion from './components/FiltersMobileVersion.vue'
import { useOptions } from './composables/useOptions'
import { sanitizeQueryParams } from './utils/sanitizeQueryParams'

const emit = defineEmits(['submit'])
const route = useRoute()

const { marketOptions, categoryOptions } = useOptions()

const defaultInitialValues = getInitialValues()

const initialValues = computed(() =>
  mergeObject(defaultInitialValues, route.query as Record<string, string>),
)

const { trackClick } = useTracking()

function handleSubmit(values: FilterValues) {
  const sanitizedFilters = sanitizeQueryParams(values)

  trackClick({
    name: Object.keys(sanitizedFilters).join(' '),
    page_type: 'opportunities_pricing',
    value: Object.values(sanitizedFilters).join(' '),
    zone: 'header_filters',
    role: 'merchant',
  })

  emit('submit', sanitizedFilters)
}
</script>
